import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import {
  Switch,
  FormControlLabel,
  TextField,
  Grid,
  CardActions,
  CardContent,
  CardHeader,
  Card,
  Loading,
} from "../../../components";
import { GrupoServicoService, notification } from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import grupoServicoValidator from "./middlewares/grupo-servico.validator";
import { GrupoServicoEntity } from "../entities";

const AddGrupoServico = ({
  id,
  handleCloseDialog,
  buscaGruposServico,
  isFullscreenDialog,
  handleCloseFullscreenDialog,
}) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-servicos-visualizar");
  const [loading, setLoading] = useState(false);
  const [grupoServico, setGrupoServico] = useState({
    ativado: true,
  });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const grupoServicoService = new GrupoServicoService();

  useEffect(() => {
    if (!id) return;
    buscaGrupoServico(id);
  }, []);

  const buscaGrupoServico = async (id) => {
    const response = await grupoServicoService.getById(id);
    setGrupoServico(response.data);
  };

  const handleInputChange = (event) => {
    setGrupoServico((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    grupoServicoValidator
      .validate(grupoServico, { abortEarly: false })
      .then(async () => {
        const grupoServicoEntity = new GrupoServicoEntity(grupoServico);
        if (id) {
          const response = await grupoServicoService.atualizar(
            id,
            grupoServicoEntity,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.alteracaoSucesso();
            buscaGruposServico();
          } else {
            responseErros(response);
          }
        } else {
          const response = await grupoServicoService.cadastrar(
            grupoServicoEntity,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            if (!isFullscreenDialog) {
              handleCloseDialog();
              notification.cadastroSucesso();
              buscaGruposServico();
            } else {
              handleCloseFullscreenDialog();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    setGrupoServico(null);
    if (isFullscreenDialog) {
      handleCloseFullscreenDialog();
    } else handleCloseDialog();
  };

  return (
    <>
      <Card className="p-3">
        <CardHeader
          title={id ? "Editar Grupo de Servico" : "Cadastrar Grupo de Servico"}
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={grupoServico?.ativado || false}
                  onChange={() =>
                    setGrupoServico((prevState) => ({
                      ...prevState,
                      ativado: !prevState?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={grupoServico?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={grupoServico?.descricao || ""}
                onChange={(event) => {
                  setInputErro([]);
                  handleInputChange(event);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            variant="contained"
            disabled={!permissoesHelper.temPermisao("grupo-servicos-cadastrar")}
            onClick={handleSubmit}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button color="padrao" variant="contained" onClick={handleCancelar}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </>
  );
};

export default AddGrupoServico;
